import { resolveBootstrapUserConfig } from '../userConfig/userConfigBootstrapCache';
import { applyUserConfigToDom } from '../userConfig/userConfigModel';

export function initializeLocale(): void {
  applyUserConfigToDom(resolveBootstrapUserConfig());
}
